import { Modal } from 'antd'

interface PurgeDataModalProps {
  visible: boolean
  onConfirm: () => void
  onCancel: () => void
}

export function PurgeDataModal({ visible, onConfirm, onCancel }: PurgeDataModalProps) {
  return (
    <Modal
      title="Purge Data"
      open={visible}
      onOk={onConfirm}
      onCancel={onCancel}
      okText="Purge Data"
      cancelText="Cancel"
      okButtonProps={{
        className: 'bg-[#132b51] hover:bg-[#0f1f3c]',
      }}
    >
      <p>
        Are you sure you want to purge sensitive data for this event? This will replace personal
        data with masked values while keeping full names for historical reference.
      </p>
      <p className="text-red-500 mt-4">This action cannot be undone.</p>
    </Modal>
  )
}

